const KENTIK_TENANCY_ID = 'ocid1.tenancy.oc1..aaaaaaaaau7s2ul5f4egoc5ogvofp22gt6y6gps6vxco7huazjvke5lcvfrq';
const KENTIK_USER_GROUP_ID = 'ocid1.group.oc1..aaaaaaaaiqoqvp4hqfjmjftbab6q3yo3uxny57mxdko6uqyhm536wiy2zj7a';
const KENTIK_USER_GROUP_ID_OUR1 = 'ocid1.group.oc1..aaaaaaaafh42eh5euiqsnu4jqyruzeov6tkl2v5hqdlswnzcow4vhherr3bq';

const OCI_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2sbJHU32oEPOnqVpWD0G
beJwVBvhyb4Y+rmJYCG1EyqH5PscIhJG6TLPs3iS599gpuUPeNR7WqKno6Bdrts6
WgyQeJh+n9yInSvJPpmGN1mU1EGiCuXYBSR0DaOUEN1ZMvUm5bm4yHxonbFSqTGn
7yGe6/kY2eGVfs6tTbcC5eSswxIrolWahYAFGVHnHV4k3ER2acRMYrYjKWrjPyN2
EYJAuzvPtIrDLiRCAM0WioGp6wx2bJJvpUaDxat2ka+Q6XviG6miPzYTo3YJoAbQ
2sNEIhNFzpsNBGCDlaahGyt4cw0XBKKwPCzcDN3yU7BXHRZiiMIkvLpL/hnXmCWe
twIDAQAB
-----END PUBLIC KEY-----`;

module.exports = {
  KENTIK_TENANCY_ID,
  KENTIK_USER_GROUP_ID,
  KENTIK_USER_GROUP_ID_OUR1,
  OCI_PUBLIC_KEY
};
